export const HostedPaymentVendor = Object.freeze({
    SlimCD: 1,
    Paymentus: 2,
    Forte: 3,
    AuthorizeNet: 4
});